module.exports = __webpack_public_path__ + "static/banner-tablet-4add02cbcf3e2a87260456f2e0b94d86.png";